module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("To Catch a Thief")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "tit"
    }
  }, [_c('h2', {
    staticClass: "titlePageAuthor"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHRISTINA SKYE")])])]), _c('h2', {
    staticClass: "titlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("TO CATCH A THIEF")])])])])]), _c('p', {
    staticClass: "titlePageLogo"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/logo.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed13ee0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tocatchathief_tit.vue
// module id = 63
// module chunks = 0